import { styled, Divider } from '@mui/material';

export const StyledDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.text.primary,
  // marginBlock: theme.spacing(4),
}));
